import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
    providedIn: 'root'
  })
  
export class VisibilityService{
    appurl = environment.apiUrl + '/v2/api';
    // GET_STUDYVISIBILITY = environment.apiUrl + '/v2/api/getStudyVisibility';
    // SET_STUDYVISIBILITY = environment.apiUrl + '/v2/api/setStudyVisibility';
    GET_STUDYVISIBILITY = '/v2/api/getStudyVisibility';
    SET_STUDYVISIBILITY = '/v2/api/setStudyVisibility';
    GET_SUPERSET_DASHBOARD_STUDY_WISE = '/v2/superset-dash/getStudyWise';
    GET_STUDY_DETAILS = '/v2/superset-dash/getStudyDetails';
    
    studyInfo: any;
    // access = JSON.parse(localStorage.getItem('access'));
    httpPostOptions = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true
    };

    private apiRequestHttpOptions:any = {
        httpOptions:this.httpPostOptions
      };
    constructor(private http: HttpClient, private apiRequest: ApiRequestService){

    }
    getStudyVisiblity(studtId: string): Observable<any>{
        this.studyInfo = {study_id: studtId};
        return this.apiRequest.request('POST',this.GET_STUDYVISIBILITY,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.GET_STUDYVISIBILITY, this.studyInfo, this.httpPostOptions);
    }
    setStudyVisiblity(studtId: string, miscData:any): Observable<any>{
        this.studyInfo = {study_id: studtId, misc:miscData};
        return this.apiRequest.request('POST',this.SET_STUDYVISIBILITY,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.SET_STUDYVISIBILITY, this.studyInfo, this.httpPostOptions);
    }

    getStudyWiseSupersetDashboard(studtId: string, miscData:any): Observable<any>{
        this.studyInfo = {study_id: studtId};
        return this.apiRequest.request('POST',this.GET_SUPERSET_DASHBOARD_STUDY_WISE,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.GET_SUPERSET_DASHBOARD_STUDY_WISE, this.studyInfo, this.httpPostOptions);
    }


    getStudyDetails(studtId: string): Observable<any>{
        this.studyInfo = {study_id: studtId};
        return this.apiRequest.request('POST',this.GET_STUDY_DETAILS,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.GET_STUDY_DETAILS, this.studyInfo, this.httpPostOptions);
    }

   
}